var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3607",
    "data-name": "Rectangle 3607",
    width: 24,
    height: 24,
    transform: "translate(7994 679)",
    fill: "#8a8a8a",
    stroke: "#5e5e5e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_221",
    "data-name": "Mask Group 221",
    transform: "translate(-7994 -679)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(7993.2 678.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M13.078,5.064a.4.4,0,0,0-.553,0l-9.2,8.794a.4.4,0,0,0-.124.289V22.4A1.6,1.6,0,0,0,4.8,24H9.6a.8.8,0,0,0,.8-.8V16.4a.4.4,0,0,1,.4-.4h4a.4.4,0,0,1,.4.4v6.8a.8.8,0,0,0,.8.8h4.8a1.6,1.6,0,0,0,1.6-1.6V14.147a.4.4,0,0,0-.124-.289Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M24.546,12.208,20.806,8.63V3.2a.8.8,0,0,0-.8-.8h-2.4a.8.8,0,0,0-.8.8V4.8l-2.9-2.769a1.641,1.641,0,0,0-2.217,0L1.058,12.207a.816.816,0,0,0-.067,1.119.8.8,0,0,0,1.158.053L12.525,3.464a.4.4,0,0,1,.553,0l10.376,9.915a.8.8,0,0,0,1.129-.022.82.82,0,0,0-.038-1.148Z",
    fill: "#8a8a8a",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGray);
export default __webpack_public_path__ + "static/media/home_gray.476211252e07d34afc569e8365cc7ca1.svg";
export { ForwardRef as ReactComponent };